import { ReactNode } from 'react';

import { Box, BoxContent, Columns } from '@bytel/trilogy-react';

import { MarketLineType } from '@app-types/contract';
import { UserType } from '@app-types/user';

import { Container } from './container';
import { LineType, LineTypeEnum, Lines } from './lines';
import { NoProposedLines, NoProposedLinesProps } from './no-proposed-lines';

interface EligibleDiscountsProps {
    user: UserType;
    proposedLinesLabel?: ReactNode;
    proposedLines?: LineType[];
    eligibleLinesLabel?: ReactNode;
    eligibleLines?: LineType[];
    noProposedLinesOptions?: Omit<NoProposedLinesProps, 'user'>;
    isLoading?: boolean;
}

export function EligibleDiscounts({
    user,
    proposedLinesLabel = 'Vous choisissez une Bbox',
    proposedLines = [],
    eligibleLinesLabel = <>Et hop, vous économisez aussi sur vos forfaits&nbsp;!</>,
    eligibleLines = [],
    noProposedLinesOptions,
    isLoading = false,
}: Readonly<EligibleDiscountsProps>) {
    const totalDiscountAmount = [...proposedLines, ...eligibleLines].reduce(
        (acc, line) => acc + (line.discount ?? 0),
        0,
    );

    if (isLoading) {
        return <Skeleton />;
    }

    return (
        <Container user={user} totalDiscountAmount={totalDiscountAmount} hideTitle={proposedLines.length <= 0}>
            <Box>
                <BoxContent>
                    {totalDiscountAmount < 0 ? (
                        <Columns>
                            <Lines
                                step={1}
                                type={LineTypeEnum.PROPOSED}
                                label={proposedLinesLabel}
                                lines={proposedLines}
                                showStep={eligibleLines.length > 0}
                            />
                            {eligibleLines.length > 0 && (
                                <Lines
                                    step={2}
                                    type={LineTypeEnum.ELIGIBLE}
                                    label={eligibleLinesLabel}
                                    lines={eligibleLines}
                                    mainOfferLabel={
                                        proposedLines[0]?.marketLine === MarketLineType.FNB ? 'forfait mobile' : 'Bbox'
                                    }
                                    showStep
                                />
                            )}
                        </Columns>
                    ) : (
                        <NoProposedLines user={user} {...noProposedLinesOptions} />
                    )}
                </BoxContent>
            </Box>
        </Container>
    );
}

function Skeleton() {
    return (
        <Container>
            <Box className='is-loading'>
                <Columns>
                    <Lines
                        step={1}
                        type={LineTypeEnum.PROPOSED}
                        label='Lorem ipsum dolor sit amet, consectetur'
                        lines={[
                            {
                                label: 'Bbox must ou ultym',
                                discount: 10000,
                                marketLine: MarketLineType.FAI,
                            },
                        ]}
                        showStep
                    />
                    <Lines
                        step={2}
                        type={LineTypeEnum.ELIGIBLE}
                        label='Lorem ipsum dolor sit amet, consectetur'
                        lines={[
                            {
                                label: 'Bbox must ou ultym',
                                discount: 10000,
                                marketLine: MarketLineType.FAI,
                            },
                        ]}
                        showStep
                    />
                </Columns>
            </Box>
        </Container>
    );
}
